<h1 class="textS+" style="text-align: center; height: 10%" mat-dialog-title>
  {{this.localiser.get("users.sureToDelete")}}
</h1>

<div mat-dialog-content class="bodyForm">
  <div class="middleText">
    <div class="row rowForm" style="margin-bottom: 4%">
      <div class="col">
        <h4 class="textS">{{this.localiser.get("profile.name")}}</h4>
        <h4 class="textS underline">{{this.data.usuario.nombre}}</h4>
      </div>
      <div class="col">
        <h4 class="textS">{{this.localiser.get("profile.surname")}}</h4>
        <h4 class="textS underline">{{this.data.usuario.apellidos}}</h4>
      </div>
    </div>
    <div class="row rowForm" style="margin-bottom: 4%">
      <div class="col">
        <h4 class="textS">{{this.localiser.get("profile.email")}}</h4>
        <h4 class="textS underline">{{this.data.usuario.email}}</h4>
      </div>
      <div class="col">
        <h4 class="textS">{{this.localiser.get("profile.phone")}}</h4>
        <h4 class="textS underline">{{this.data.usuario.telefono}}</h4>
      </div>
    </div>
    <div class="row rowForm" style="margin-bottom: 4%">
      <div class="col">
        <h4 class="textS">{{this.localiser.get("users.company")}}</h4>
        <h4 class="textS underline">{{this.data.empresa.nombre}}</h4>
      </div>
      <div class="col">
        <h4 class="textS">{{this.localiser.get("users.permissions")}}</h4>
        <h4 class="textS underline">{{this.data.usuario.idPermiso}}</h4>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <div class="col" style="text-align: center">
    <button class="customButtonColor textS" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
  </div>

  <div class="col" style="text-align: center">
    <button class="customButtonColorDelete textS" mat-button (click)="deleteUser()">{{this.localiser.get("button.delete")}}</button>
  </div>
</div>
